export default new class Cart {
    constructor() {
        this.sAddonClass = '_addon';
        this.sCartWrapperClass = '_cart_wrapper';

        this.change();
    }

    change() {
        $(document).on('change', `.${this.sAddonClass}`, (obEvent) => {
            let obData = {'data': {}};

            $(`.${this.sAddonClass}:checkbox:checked`).each(function(){
                obData.data[$(this).attr('name')] = $(this).val();
            });

            oc.request(obEvent.target, 'onInit', {
                data: obData,
                update: {
                    'order/cart': `.${this.sCartWrapperClass}`
                }
            });
        });
    }
}();
